import {
  ClipboardDocumentListIcon,
  HomeIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import React, { useEffect, useMemo } from 'react';
import { JSX } from 'react/jsx-runtime';

import { DocumentsSections } from '@/components/documents/DocumentsSections';
import { useEntitlements } from '@/hooks/useEntitlements';
import { useAuth } from '@/state/auth';
import { MyFile } from '@/types';
import { useStorage } from '@/utils/storage/useStorage.util';

interface Folder {
  label: string;
  query?: string;
  children?: Folder[] | ((files: MyFile[], parentQuery: string) => Folder[]);
  level?: number;
  data?: MyFile[];
  icon?: JSX.Element;
}

// Note: "Reports" lives in its own tab now (ReportsTab), so it is intentionally
// absent here. This tree only covers the generic file browser folders.
const TreeData: Folder[] = [
  {
    label: 'My Files',
    query: 'home',
    icon: <HomeIcon className="size-6" />,
  },
  {
    label: 'Procedures',
    query: 'malware',
    icon: <ClipboardDocumentListIcon className="size-6" />,
  },
  {
    label: 'Proof of Exploits',
    query: 'proofs',
    icon: <ShieldCheckIcon className="size-6" />,
  },
];

export const FilesTab: React.FC = () => {
  const [defaultDir, setDefaultDir] = useStorage<string>(
    { key: 'files/defaultDir' },
    'home'
  );
  const currentFolder = useMemo<Folder>(
    () => TreeData.find(d => d.query === defaultDir) ?? TreeData[0],
    [defaultDir]
  );

  const { isPraetorianUser } = useAuth();
  const { canWriteFiles } = useEntitlements();

  useEffect(() => {
    setDefaultDir(currentFolder.query ?? '');
  }, [currentFolder]);

  return (
    <DocumentsSections
      query={currentFolder.query ? `${currentFolder.query}` : 'home'}
      enableUpload={canWriteFiles}
      enableSearch={true}
      enableFavorites={true}
      isPraetorianUser={isPraetorianUser}
    />
  );
};
